export const TABLE_UPDATE = "ORDER_V2_LOCATION_GROUPS/TABLE_UPDATE";
export const FETCH_SUCCESS = "ORDER_V2_LOCATION_GROUPS/FETCH_SUCCESS";

const types = {
    DESTROY_FAILED: "ORDER_V2_LOCATION_GROUPS/DESTROY_FAILED",
    DESTROY_REQUEST: "ORDER_V2_LOCATION_GROUPS/DESTROY_REQUEST",
    DESTROY_SUCCESS: "ORDER_V2_LOCATION_GROUPS/DESTROY_SUCCESS",

    FETCH_FAILED: "ORDER_V2_LOCATION_GROUPS/FETCH_FAILED",
    FETCH_REQUEST: "ORDER_V2_LOCATION_GROUPS/FETCH_REQUEST",
    FETCH_SUCCESS,

    FETCH_ALL_FAILED: "ORDER_V2_LOCATION_GROUPS/FETCH_ALL_FAILED",
    FETCH_ALL_REQUEST: "ORDER_V2_LOCATION_GROUPS/FETCH_ALL_REQUEST",
    FETCH_ALL_SUCCESS: "ORDER_V2_LOCATION_GROUPS/FETCH_ALL_SUCCESS",

    GET_FAILED: "ORDER_V2_LOCATION_GROUPS/GET_FAILED",
    GET_REQUEST: "ORDER_V2_LOCATION_GROUPS/GET_REQUEST",
    GET_SUCCESS: "ORDER_V2_LOCATION_GROUPS/GET_SUCCESS",

    PATCH_FAILED: "ORDER_V2_LOCATION_GROUPS/PATCH_FAILED",
    PATCH_REQUEST: "ORDER_V2_LOCATION_GROUPS/PATCH_REQUEST",
    PATCH_SUCCESS: "ORDER_V2_LOCATION_GROUPS/PATCH_SUCCESS",

    STORE_FAILED: "ORDER_V2_LOCATION_GROUPS/STORE_FAILED",
    STORE_REQUEST: "ORDER_V2_LOCATION_GROUPS/STORE_REQUEST",
    STORE_SUCCESS: "ORDER_V2_LOCATION_GROUPS/STORE_SUCCESS",

    UPDATE_FAILED: "ORDER_V2_LOCATION_GROUPS/UPDATE_FAILED",
    UPDATE_REQUEST: "ORDER_V2_LOCATION_GROUPS/UPDATE_REQUEST",
    UPDATE_SUCCESS: "ORDER_V2_LOCATION_GROUPS/UPDATE_SUCCESS",
    TABLE_UPDATE,
};

export default types;
